import { URL } from '../constant';
import http from '../http/http';

export const mainDataSelAPI = async (params) => {
  let result = null;
  const { channel = 'BRS1000', language = 'KO', lrnMbrId } = params;
  await http.request({
    url: `${URL.API.GLOBAL.MAIN}/channel/${channel}/language/${language}/member/${lrnMbrId}`,
    success: (resp) => {
      result = resp;
    },
    error: (error) => {
      throw error;
    }
  });

  return result;
}


export const couresNextLevelSelAPI = async (data) => {
  let result = null;
  const { learnerId, level } = data;
  await http.request({
    url: `${URL.API.LEARNING.COURSE}/level/history/member/${learnerId}/level/${level}`,
    method: http.METHOD.POST,
    success: (resp) => {
      result = resp;
    },
    error: (error) => {
      throw error;
    }
  });

  return result;
}

// 게스트 확인 및 게스트 생성
export const guestSelAndReg = async (data) => {
  let result = null;

  await http.request({
    url: `${URL.API.GLOBAL.GUEST_SEL_REG}`,
    method: http.METHOD.POST,
    data,
    success: (resp) => {
      result = resp;
    },
    error: (error) => {
      throw error;
    }
  });

  return result;
}

// 게스트 계정 가입 계정으로 전환
export const guestJoin = async (data) => {
  let result = null;

  await http.request({
    url: `${URL.API.GLOBAL.GUEST_JOIN}`,
    method: http.METHOD.POST,
    data,
    success: (resp, code) => {
      result = { resp, code }
    },
    error: (error) => {
      if (error?.code) result = { code: error.code, resp: error };
      else throw error;
    }
  });
  console.log({ result });
  return result;
}

// 워크시트 문항 조회
export const worksheetListSelAPI = async(data) => {
  let result = null;
  await http.request({
    url: `${URL.API.GLOBAL.WORK_SHEET}`,
    method: http.METHOD.POST,
    data,
    success: (resp, code) => {
      result = { data: resp, code }
    },
    error: (error) => {
      if (error?.code) result = { code: error.code, resp: error };
      else throw error;
    }
  });

  return result;
}

// qr 워크시트 문항 조회
export const qrWorksheetListSelAPI = async(data) => {
  let result = null
  await http.request({
    url: `${URL.API.GLOBAL.QR_WORK_SHEET}`,
    method: http.METHOD.POST,
    data,
    success: (resp, code) => {
      result = { data: resp, code }
    },
    error: (error) => {
      if (error?.code) result = { code: error.code, resp: error };
      else throw error;
    }
  });

  return result;
}

// 워크시트 이메일 발송
export const worksheetEmailSendAPI = async(data) => {
  let result = null;
  await http.request({
    url: `${URL.API.GLOBAL.WORK_SHEET_EMAI_SEND}`,
    method: http.METHOD.POST,
    data,
    success: (resp, code) => {
      result = { resp, code }
    },
    error: (error) => {
      if (error?.code) result = { code: error.code, resp: error };
      else throw error;
    }
  });

  return result;
}